// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2tekl","wrapper":"styles_wrapper__16Sst","text":"styles_text__37rkD"};